import { localeUtilsFactory } from 'wix-style-react-tpa';
import { endOfWeek, startOfWeek, isSameWeek, addWeeks } from 'date-fns';
export const getWeekDatesRange = (date, firstDayOfWeek = 1) => {
    const startOfTheWeek = startOfWeek(date, { weekStartsOn: firstDayOfWeek });
    const endOfTheWeek = endOfWeek(date, { weekStartsOn: firstDayOfWeek });
    return { startOfWeek: startOfTheWeek, endOfWeek: endOfTheWeek };
};
export const areDatesInTheSameWeek = (firstDate, secondDate, firstDayOfWeek = 1) => {
    return isSameWeek(firstDate, secondDate, { weekStartsOn: firstDayOfWeek });
};
export const getOffsetWeekDatesRange = (currentWeek, offset, { locale, firstDayOfWeek, }) => {
    const { getFirstDayOfWeek } = localeUtilsFactory(locale, firstDayOfWeek);
    const firstDayOfTheWeek = getFirstDayOfWeek();
    const newStartOfWeek = addWeeks(currentWeek, offset);
    return getWeekDatesRange(newStartOfWeek, firstDayOfTheWeek);
};
export const getCaptionText = (weekRange, locale, firstDayOfWeek) => {
    const { formatMonthAndYear, formatMonthsRange } = localeUtilsFactory(locale, firstDayOfWeek);
    if (weekRange.startOfWeek.getMonth() === weekRange.endOfWeek.getMonth()) {
        return formatMonthAndYear(weekRange.endOfWeek);
    }
    return formatMonthsRange(weekRange.startOfWeek, weekRange.endOfWeek);
};
//# sourceMappingURL=dateUtils.js.map